// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DownloadCashAppCTASubmitSmsToDownloadEvent
 */
export var DownloadCashAppCTASubmitSmsToDownload = function (_a) {
    var pageName = _a.pageName, ctaText = _a.ctaText;
    return ({
        name: "DownloadCashAppCTA Submit SmsToDownload",
        parameters: {
            cdf_entity: "DownloadCashAppCTA",
            cdf_action: "Submit",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cta_text: ctaText !== undefined && ctaText !== null ? ctaText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DownloadCashAppCTASubmitDownloadButtonEvent
 */
export var DownloadCashAppCTASubmitDownloadButton = function (_a) {
    var pageName = _a.pageName, ctaText = _a.ctaText, ctaUrl = _a.ctaUrl;
    return ({
        name: "DownloadCashAppCTA Submit DownloadButton",
        parameters: {
            cdf_entity: "DownloadCashAppCTA",
            cdf_action: "Submit",
            page_name: pageName !== undefined && pageName !== null ? pageName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cta_text: ctaText !== undefined && ctaText !== null ? ctaText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cta_url: ctaUrl !== undefined && ctaUrl !== null ? ctaUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DownloadCashAppCTARedirectWebEvent
 */
export var DownloadCashAppCTARedirectWeb = function (_a) {
    var campaign = _a.campaign, destination = _a.destination;
    return ({
        name: "DownloadCashAppCTA Redirect Web",
        parameters: {
            cdf_entity: "DownloadCashAppCTA",
            cdf_action: "Redirect",
            campaign: campaign !== undefined && campaign !== null ? campaign.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            destination: destination !== undefined && destination !== null ? destination.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
